<template>
   <div class="invalid-feedback" style="display:block;" v-if="typeof validationErrors[element] !== 'undefined'">
       <div v-if="!message" >
            <div  v-for="validationerror in validationErrors[element]" v-bind:key="validationerror">
                <p>{{validationerror}}</p>
            </div>
        </div>
        <p v-else>
            {{message}}
        </p>
    </div>
</template>
<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'validation',
    props: ['element','message'],
    computed: {
        ...mapGetters('errors',['validationErrors'])
    }
}
</script>
